import PropTypes from "prop-types";
import RemineDial from "@shared/RemineDial";
import SellScoreTooltip from "@shared/SellScoreTooltip";

const LEVEL_LABELS = {
  low: "low",
  med: "medium",
  high: "high",
};

const isMultiLevel = (level) => level != null && !Number.isNaN(Number(level));

const RemineCard = ({ level, addressType }) => {
  const isMulti = level === "multi" || isMultiLevel(level);

  return (
    <div className="tw-flex tw-items-center tw-rounded-lg tw-border tw-border-solid tw-border-[#ebebeb] tw-bg-white tw-p-3">
      <div className="tw-flex tw-flex-1 tw-items-center tw-gap-3 tw-min-w-0">
        <RemineDial level={level} size={50} />
        <div className="tw-text-xs tw-leading-4 tw-text-[#666] tw-min-w-0 tw-text-12d">
          {isMulti ? (
            <div className="tw-flex tw-flex-col tw-text-12d">
              <span className="tw-font-bold">Multiple sell scores </span>
              <span>available for this lead</span>
            </div>
          ) : (
            <div className="tw-text-12d">
              <span>This lead&#39;s </span>
              <span className="tw-font-bold">{addressType} </span>
              <span>has a {LEVEL_LABELS[level] || "low"} sell score</span>
            </div>
          )}
        </div>
        {!isMulti ? <SellScoreTooltip sellScore={level} tooltipClassName="tw-mr-[8.5px]" /> : null}
      </div>
    </div>
  );
};

RemineCard.propTypes = {
  level: PropTypes.oneOfType([
    PropTypes.oneOf(["low", "med", "high", 'multi']),
    PropTypes.number,
    PropTypes.string,
  ]),
  addressType: PropTypes.string,
};

RemineCard.defaultProps = {
  level: 'low',
  addressType: "home",
};

export default RemineCard;
